export default function (id, title = 'Arrematante') {
  let window = id ? `arrematante.${id}` : 'arrematante.new'
  !this.$uloc.window.get(window) && this.$uloc.window.new({
    wid: window,
    title: title + (id ? ` #${id}` : ''),
    width: '90%',
    height: '90%',
    maxWidth: '1400',
    minWidth: '1000px',
    minHeight: '500px',
    backdrop: true,
    clickOutside: false,
    windowClass: 'erp-window erp-window-with-panel',
    contentClass: 'overflow-hidden',
    props: {
      id: id,
      listClassificacao: this.listClassificacao,
      listLeiloeiros: this.listLeiloeiros,
      router: this.$router,
      screenLbl: title
    }
  }, () => import('../components/window/Arrematante.vue'))
    .then((wid) => {
      this.$uloc.window.listen(wid, {
        update: (wid, val) => {
          this.load && this.load()
        },
      })
    }) // return wid
}
